import React, { useEffect } from 'react'
import { ViewersStatisticsProps } from './ViewersStatistics.types'
import styles from './ViewersStatistics.module.scss'
import cl from 'classnames'
import { H2, SectionContainer } from 'components/shared'
import { ViewersExpandableChart } from 'components/charts'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { VIEWERS_STORE } from 'store'
import moment from 'moment'
import { formatPrice } from 'utilities'

const ViewersStatisticsComponent = (props: ViewersStatisticsProps) => {
  const {
    className,
    style,
    [VIEWERS_STORE]: {
      getViewersStats,
      uniqueProjects,
      uniqueViewers,
      totalWatchTime,
      totalInteractionTime,
      revenue,
      addExpenses,
      viewerTotalStats
    }
  } = props

  useEffect(getViewersStats, [getViewersStats])

  const totalWatchTimeLabel = moment.duration(totalWatchTime, 'milliseconds').format('hh:mm', { trim: false }) + 'h'
  const totalInteractionTimeLabel = moment.duration(totalInteractionTime, 'milliseconds').format('hh:mm', { trim: false }) + 'h'
  const addExpensesLabel = formatPrice(addExpenses)
  const revenueLabel = formatPrice(revenue)
  const sections: Map<string, string> = new Map([
    ['TOTAL WATCH TIME', totalWatchTimeLabel],
    ['TOTAL INTERACTION TIME', totalInteractionTimeLabel],
    ['AD EXPENSES', addExpensesLabel],
    ['PURCHASE REVENUE', revenueLabel]
  ])

  return (
    <SectionContainer
      className={cl(styles.container, className)}
      style={style}
    >
      <H2>Viewers statistics</H2>
      <ViewersExpandableChart
        style={{ marginTop: 20 }}
        chartHeaderProps={{
          projectsCount: uniqueProjects,
          total: `Total viewers: ${uniqueViewers}`,
          sections
        }}
        chartData={viewerTotalStats}
      />
    </SectionContainer>
  )
}

const ViewersStatistics = inject(
  VIEWERS_STORE
)(observer(ViewersStatisticsComponent))
export { ViewersStatistics }
